<template>
  <div
    style="
      height: 100%;
      display: grid;
      grid-template-rows: 1fr 1fr;
      row-gap: 25px;
    "
  >
    <v-fade-transition>
      <v-row style="width: 100%" class="ma-0 pa-0" v-show="!transition">
        <v-col class="fill-height ma-0 pa-0">
          <v-card class="fill-height rounded-10">
            <div
              v-if="scanBodySelectionLabel"
              style="position: absolute"
              class="pa-5 title-font"
            >
              Select {{ scanBodySelectionLabel }}
            </div>
            <div ref="scan1View"></div>
          </v-card>
        </v-col>
      </v-row>
    </v-fade-transition>
    <v-fade-transition>
      <v-row style="width: 100%" class="ma-0 pa-0" v-show="!transition">
        <v-col class="fill-height ma-0 pa-0">
          <v-card class="fill-height rounded-10">
            <div
              v-if="scanBodySelectionLabel"
              style="position: absolute"
              class="pa-5 title-font"
            >
              Select {{ scanBodySelectionLabel }}
            </div>
            <div ref="scan2View"></div>
          </v-card>
        </v-col>
      </v-row>
    </v-fade-transition>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex"
import * as NCFrontend from "@osteon-nexus-connect-lib/nc-frontend"

export default {
  name: "SelectionDivs",

  scan1View: null,
  scan2View: null,

  props: ["prop"],

  async mounted() {
    this.scan1View = NCFrontend.createView("scan1View", this.$refs.scan1View)
    this.scan2View = NCFrontend.createView("scan2View", this.$refs.scan2View)
    NCFrontend.add(this.scan1View, this.scan2View)
    const visualisations = await Promise.all([
      NCFrontend.Visualisations.ScanBodySelect.make(this.scan1View.element, {
        mesh: this.addScansResponse.scan1.mesh,
        detectedPlanesForScanGauges:
          this.addScansResponse.scan1.detectedPlanesForScanGauges,
        detectedPlanesForNarrowScanBodies:
          this.addScansResponse.scan1.detectedPlanesForNarrowScanBodies
      }),
      NCFrontend.Visualisations.ScanBodySelect.make(this.scan2View.element, {
        mesh: this.addScansResponse.scan2.mesh,
        detectedPlanesForScanGauges:
          this.addScansResponse.scan2.detectedPlanesForScanGauges,
        detectedPlanesForNarrowScanBodies:
          this.addScansResponse.scan2.detectedPlanesForNarrowScanBodies
      })
    ])
    this.scan1View.setVisualisation(visualisations[0])
    this.scan2View.setVisualisation(visualisations[1])
    this.setScanBodySelectionLabel("Scan Gauges")
    setTimeout(() => {
      this.setTransition(false)
    }, 300)
  },

  unmounted() {
    NCFrontend.remove(this.scan1View, this.scan2View)
  },

  methods: {
    ...mapActions(["setTransition", "setScanBodySelectionLabel"])
  },

  computed: {
    ...mapGetters([
      "upperAddScansResponse",
      "lowerAddScansResponse",
      "transition",
      "pageState",
      "scanBodySelectionLabel"
    ]),

    addScansResponse() {
      return this[`${this.prop}AddScansResponse`]
    }
  }
}
</script>
